const API_URL = `${process.env.REACT_APP_API_URL}/v1/api/getUploadUrlPre`;
const FILE_CDN_URL = (process.env.REACT_APP_FILE_URL || "").replace(/\/$/, "");
const S3_BUCKET_HOST = "refinedspaces.s3.amazonaws.com";

const toPublicFileUrl = (uploadUrl) => {
  const s3Url = uploadUrl.split("?")[0];

  if (!FILE_CDN_URL) {
    return s3Url;
  }

  try {
    const { hostname, pathname } = new URL(s3Url);
    if (hostname === S3_BUCKET_HOST) {
      return `${FILE_CDN_URL}${pathname}`;
    }
  } catch (error) {
    console.warn("Could not normalize upload URL for CDN:", error);
  }

  return s3Url;
};

const getUploadUrls = async (files) => {
  const fileData = files.map((file) => ({
    fileName: file.name,
    fileType: file.type,
  }));

  const response = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ files: fileData }),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to get upload URLs (${response.status} ${response.statusText})`,
    );
  }

  const data = await response.json();
  if (!data?.uploadUrls?.length) {
    throw new Error("Upload service did not return signed URLs.");
  }

  return data.uploadUrls;
};

const uploadFiles = async (files) => {
  if (!files.length) {
    return [];
  }

  const uploadUrls = await getUploadUrls(files);

  if (uploadUrls.length !== files.length) {
    throw new Error(
      "Upload service returned an unexpected number of signed URLs.",
    );
  }

  const uploadPromises = files.map(async (file, index) => {
    const response = await fetch(uploadUrls[index], {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to upload ${file.name} (${response.status} ${response.statusText})`,
      );
    }

    return toPublicFileUrl(uploadUrls[index]);
  });

  return Promise.all(uploadPromises);
};

export default uploadFiles;
